import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import Home from '../pages/Home';
import AllEbooks from '../pages/AllEbooks';
import AllCourses from '../pages/AllCourses';
import AllLiveClasses from '../pages/AllLiveClasses';
import AudioRooms from '../pages/AudioRooms';
import AllTeachers from '../pages/AllTeachers';

// Keep this map in sync with ALLOWED_LANDING_PAGES in
// /app/backend/services/settings/routes.py
const LANDING_COMPONENTS = {
  home: Home,
  ebooks: AllEbooks,
  courses: AllCourses,
  'live-classes': AllLiveClasses,
  'audio-rooms': AudioRooms,
  teachers: AllTeachers,
};

/**
 * Public root `/` route: picks the landing page the admin selected in
 * Settings → Layout Manager. Falls back to Home when the setting is missing
 * or the fetch fails, so the site is never blank.
 */
export default function LandingRouter() {
  const [landing, setLanding] = useState(null); // null = still loading

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/settings`)
      .then((res) => {
        if (!alive) return;
        const pick = (res.data?.landingPage || 'home').toLowerCase();
        setLanding(LANDING_COMPONENTS[pick] ? pick : 'home');
      })
      .catch(() => {
        if (alive) setLanding('home');
      });
    return () => {
      alive = false;
    };
  }, []);

  if (landing === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500" />
      </div>
    );
  }

  const Component = LANDING_COMPONENTS[landing] || Home;
  return <Component />;
}
